import { render } from "./TopChart.vue?vue&type=template&id=7fa9bdba"
import script from "./TopChart.vue?vue&type=script&lang=js"
export * from "./TopChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__